import { render, staticRenderFns } from "./ScenicCard.vue?vue&type=template&id=0312d472&scoped=true"
import script from "./ScenicCard.vue?vue&type=script&lang=js"
export * from "./ScenicCard.vue?vue&type=script&lang=js"
import style0 from "./ScenicCard.vue?vue&type=style&index=0&id=0312d472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0312d472",
  null
  
)

export default component.exports